export class ShopMarkersCtrl {
    constructor($scope, $q, mapServ, mapHelperServ, storeServ) {
        this.$scope = $scope;
        this.$q = $q;
        this.mapServ = mapServ;
        this.mapHelperServ = mapHelperServ;
        this.storeServ = storeServ;
        this.markerClickListeners = [];
        this.$onChanges = this.ngOnChanges.bind(this);
        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    ngOnChanges(changes) {
        if (changes.shopType && changes.shopType.currentValue) {
            this.ngOnDestroy();
            this.getShops();
        }
    }

    getShops() {
        this.cancelReadShopsRequest = this.$q.defer();
        this.mapServ.readShops(this.shopType, this.cancelReadShopsRequest).then((shops) => {
            this.shopMarkers = shops
                .map(this.mapServ._transformCoordinatesStringIntoObject)
                .map(this.createShopMarker.bind(this))
                .map(this.addClickListenerToMarker.bind(this));
            this.addShopMarkersToClusterer();
            this.storeServ.dispatch({
                type: 'SET_SHOP_MARKERS_READY',
                shopMarkersReady: true
            });
        });
    }

    createShopMarker(shop) {
        let lat = parseFloat(shop.placemarkPoint.coordinates.lat);
        let lng = parseFloat(shop.placemarkPoint.coordinates.lng);
        let latLng = this.mapHelperServ.getLatLng(lat, lng);
        let icon = this.mapHelperServ._getMarkerIconByShopType(shop.type && shop.subType ? shop.subType : shop.type);
        let zIndex = this.mapHelperServ._getMarkerZIndexByShopType(shop.type);
        let todaysProgram = this.mapHelperServ._getTodaysProgram(shop.program1, shop.program2, shop.program3, shop.scheduleExceptions);
        let imageUrl = shop.logoUrl !== null ? shop.logoUrl : shop.imageUrl;
        let customProperties = {
            type: 'shopMarker',
            shop: {
                city: shop.city,
                description: shop.description,
                shopUrl: shop.prettyUrl,
                prettyName: shop.prettyName,
                district: shop.county,
                pos: shop.pos,
                imageUrl: imageUrl,
                lat: lat,
                lng: lng,
                name: shop.name,
                todaysProgram: todaysProgram,
                type: shop.type
            }
        };

        return this.mapHelperServ._createMarker(latLng, icon, zIndex, customProperties);
    }

    addClickListenerToMarker(marker) {
        let listener = marker.addListener('click', this.onMarkerClick.bind(this, marker));
        this.markerClickListeners.push(listener);
        return marker;
    }

    addShopMarkersToClusterer() {
        this.markerClusterer.addMarkers(this.shopMarkers);
    }

    /**
     *  Listeners.
     */

    onMarkerClick(marker) {
        let markerPosition = marker.getPosition();
        marker.customProperties.shop.openShopDetailsUrlInNewWindow = this.openShopDetailsUrlInNewWindow || null;
        let searchedPlaceCoordinates = this.storeServ.getState().searchedPlaceCoordinates;
        if (searchedPlaceCoordinates) {
            searchedPlaceCoordinates = this.mapHelperServ.getLatLng(
                searchedPlaceCoordinates.location.lat,
                searchedPlaceCoordinates.location.lng
            );
            marker.customProperties.shop.directionsUrl = this.mapHelperServ.getDirectionUrl(searchedPlaceCoordinates, markerPosition);
            marker.customProperties.shop.distance = this.mapHelperServ.getDistance(searchedPlaceCoordinates, markerPosition);
        }

        marker.customProperties.shop.pixelOffset = -53;

        this.storeServ.dispatch({
            type: 'SET_CLICKED_SHOP_MARKER_COORDINATES',
            coordinates: null
        });

        this.storeServ.dispatch({
            type: 'SET_CLICKED_SHOP_MARKER_COORDINATES',
            coordinates: {
                lat: markerPosition.lat(),
                lng: markerPosition.lng()
            }
        });

        this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: null
        });

        this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: {
                template: 'shopMarker',
                markerProperties: marker.customProperties.shop
            }
        });
    }

    /**
     *  Workers.
     */

    removeClickListenersFromMarkers() {
        this.markerClickListeners.forEach((listener) => {
            listener.remove();
        });
    }

    removeMarkersFromMap() {
        if (this.shopMarkers) this.shopMarkers.forEach((marker) => {
            marker.setMap(null);
        });
    }

    clearShopMarkersFromClusterer() {
        this.markerClusterer.clearMarkers();
    }

    /**
     *  Destroy.
     */

    ngOnDestroy() {
        if (this.cancelReadShopsRequest) {
            this.cancelReadShopsRequest.resolve();
        }

        this.removeClickListenersFromMarkers();

        this.removeMarkersFromMap();

        this.clearShopMarkersFromClusterer();

        this.storeServ.getState().shopMarkersReady && this.storeServ.dispatch({
            type: 'SET_SHOP_MARKERS_READY',
            shopMarkersReady: false
        });

        this.storeServ.getState().setClickedShopMarkerCoordinates && this.storeServ.dispatch({
            type: 'SET_CLICKED_SHOP_MARKER_COORDINATES',
            coordinates: null
        });

        this.storeServ.getState().toggleInfoWindow && this.storeServ.dispatch({
            type: 'TOGGLE_INFO_WINDOW',
            props: null
        });
    }
}

ShopMarkersCtrl.$inject = ['$scope', '$q', 'mapServ', 'mapHelperServ', 'storeServ'];

const shopMarkersDirective = function () {
    return {
        restrict: 'E',
        scope: {},
        template: '',
        controllerAs: 'shopMarkersCtrl',
        controller: ShopMarkersCtrl,
        bindToController: {
            openShopDetailsUrlInNewWindow: '<',
            markerClusterer: '<',
            shopType: '<'
        }
    };
};

export default shopMarkersDirective;
